import Cookies from 'js-cookie';
export const fbTrack = (type, eventName, customData, cache = false) => {
    if (!cache || (cache && !Cookies.get(`fb${eventName}`))) {
        if (type && eventName && typeof window.fbq === 'function') {
            window.fbq(type, eventName, customData);
            if (cache)
                Cookies.set(`fb${eventName}`, true);
        }
    }
};
//# sourceMappingURL=fb-track.js.map